import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {FormBuilder} from "@angular/forms";
import {HttpClient} from "@angular/common/http";
import {AuthService} from "angular2-social-login";
import {Conf} from "../settings/config";
import {FunctionsService} from "../services/functions.service";


@Component({
  selector: 'app-competitions-list',
  templateUrl: './competitions-list.component.html'
})
export class CompetitionsListComponent implements OnInit {

  public slug = '';
  banner_image = './assets/images/banners/be-inspired-banner.jpg';

  category = {
    id: '',
    title: '',
    content: '',
    cover_image: ''
  };
  competitions = [];
  regions = [];
  categories = [];
  selected_categories = '';

  constructor(private route: ActivatedRoute, private router: Router, private fb: FormBuilder, private http: HttpClient, public _auth: AuthService) {

  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      if (params.slug) {
        this.slug = params['slug'];
        this.getCategory();
      }
      this.getCompetition();
    });

    this.getCategories();
  }

  selectCategory(slug) {
    this.slug = slug;
    this.getCompetition()
  }

  getCategory() {
    this.http.get(Conf.API_URL + '/category-for-competition/?show_all&slug=' + this.slug).subscribe(
        data => {
          this.category.title = data['results'][0]['title'];
        },
        error => {
          console.log(error.error)
        }
    );
  }

  getCategories() {
    this.http.get(Conf.API_URL + '/category-for-competition/?show_all&count=0').subscribe(
        data => {
          this.categories = data['results'];
        },
        error => {
          console.log(error.error)
        }
    );
  }

  getCompetition() {
    var url = Conf.API_URL + '/competition/?show_all&category=' + this.slug;

    this.http.get(url).subscribe(
        data => {
          this.competitions = data['results'];
        },
        error => {
          console.log(error.error)
        }
    );
  }

  firstParagraph(html) {
    return FunctionsService.firstParagraph(html)
  }
}




// WEBPACK FOOTER //
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/competitions-list/competitions-list.component.ts